import React from "react";
import LoginForm from "./LoginForm";
import loginImg from "../../../assets/images/login.png";
function LoginLayout() {
  return (
    <div className="container my-4">
      <div className="row align-items-center">
        <div className="col-12 col-lg-6">
          <div className="d-none d-lg-block">
            <img
              className="w-100 AuthlandingImg h_550x object-fit-cover br_25"
              src={loginImg}
              alt=""
            />
          </div>
        </div>
        <div className="col-12 col-lg-6 mt-3 mt-lg-0">
          <LoginForm />
        </div>
      </div>
    </div>
  );
}

export default LoginLayout;
